<template>
  <div>
    <v-card-text>
      <v-row>
        <v-list>
          <v-list-item>
            <v-list-item-avatar
              height="100px"
              width="100px"
              class="avatar">
              <v-img v-bind:src="avatar_img"></v-img>
              <div
                class="description-upload-photo">
                  <span>Загрузить фото</span>
                <input
                  type="file"
                  @change="onUploadFile"
                  name="Загрузить фото"
                  accept="image/gif, image/jpeg, image/png"
                />
              </div>
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-list-item-title
                  class="title"> {{last_name}} {{name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{email}}</v-list-item-subtitle>

              </v-skeleton-loader>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
          v-model="last_name"
          :label="surNameLabel"
          required></v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-text-field
              v-model="name"
              :label="nameLabel"
              required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
              v-model="middle_name"
              :label="patronymicLabel" required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-autocomplete
            v-model="currentOrganization"
            :items="fullOrganizationArray"
            item-text="name"
            item-value="id"
            :label="scienceOrganizationLabel"
            prepend-icon="mdi-city"
          ></v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col  cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-text-field
              v-model="phone"
              :label="phoneLabel"
              required
              prepend-icon="mdi-phone"></v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentDegree"
              :items="fullDegreeArray"
              item-text="title"
              item-value="id"
              :label='scienceDegreeLabel'
              prepend-icon="mdi-badge-account-outline">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentOrgPosition"
              :items="fullOrgPosinions"
              item-text="title"
              item-value="id"
              label='Должность'
              prepend-icon="mdi-badge-account-outline">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6">
          <div class="d-flex " style="height:40px; margin-top:10px;">
            <h1 class="switch__current-lang"  x-snall style=" padding-top: 19px;">Пол: Мужской</h1>
            <v-switch  style="color:white;" v-model="is_female" label="Женский"></v-switch>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-skeleton-loader

                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field

                  v-model="computedDateFormatted"
                  :label="birthDayLabel"
                  :hint="hint"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </v-skeleton-loader>
            </template>
            <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="#4dbee1"
        dark
        outlined
        label
        class="mr-4 ml-2"
        :loading="loaded"
        @click="save_btn"
      >обновить личные данные</v-btn>
    </v-card-actions>

  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { parserDate, parserString } from '../../helpers/parserDate';
import { AUTH_URL, REFERENCES_URL, USER_URL } from '../../../vars';
import user from '../../assets/user.png';

export default {
  mounted() {
    this.uploadDataUser();
  },
  name: 'personalDataBase',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  data: () => ({

    title: 'This will be the title',
    boilerplate: true,
    loading: false,
    name: '',
    middle_name: '',
    loginChecked: true,
    last_name: '',
    avatar_img: user,
    email: '',
    phone: '',
    model: null,
    academic_rank: null,
    currentDegree: null,
    currentOrgPosition: null,
    is_female: false,
    currentOrganization: null,
    date: new Date().toISOString().substr(0, 10),
    menu2: false,
    head_info: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    edit: false,
    organizations: null,
    fullDegreeArray: null,
    fullOrgPosinions: null, 
    fullOrganizationArray: [],
    loaded: false,
    reg_count: 0,
  }),
  components: {
  },
  watch: {
    GETTERS_PHOTO_USER(val) {
      this.avatar_img = val;
    },
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
      'GETTERS_PHOTO_USER',
    ]),

    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      return errors;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    surNameLabel() {
      return 'Фамилия';
    },
    scienceOrganizationLabel() {
      return 'Научная организация';
    },
    nameLabel() {
      return 'Имя';
    },
    patronymicLabel() {
      return 'Отчество';
    },
    hint() {
      return 'мм/дд/гггг формат';
    },
    birthDayLabel() {
      return 'Дата рождения'
    },
    phoneLabel() {
      return 'Телефон'
    },
    scienceRankLabel() {
      return 'Научное звание'
    },
    scienceDegreeLabel() {
      return 'Научная степень'
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      return errors;
    },

  },
  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'LOAD_PHOTO',
      'UPDATE_INDIVIDUAL',
      'GET_ACADEMIC_DEGREE',
      'GET_ORG_POSITION_LIST',
      'ORGANIZATION_HEADERS',
      'GET_PERSONAL_DATA',
      'logged',
      'FILE_SEND',
      'ADD_THESIS_FILE',
      'CHANGE_REGISTRATION',
      'MAKE_INVITE',
      'MAKE_SERT'
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),


    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });
        const degree = await this.GET_ACADEMIC_DEGREE();
        const orgs_positions = await this.GET_ORG_POSITION_LIST();
        const organizations = await this.ORGANIZATION_HEADERS();

        this.fullOrganizationArray = organizations.data;
        this.fullDegreeArray = degree.data;
        this.fullOrgPosinions = orgs_positions.data;

        this.organizations = organizations.data.map((item) => item.name);

        if (this.GETTERS_LOGIN) {
          this.edit = true;
          const data = await this.GET_PERSONAL_DATA();
          this.email = data.username;
          this.last_name = data.profiles[0].individual.last_name;
          this.phone = data.profiles[0].individual.phone_number;
          this.name = data.profiles[0].individual.first_name;
          this.middle_name = data.profiles[0].individual.middle_name || '';
          this.currentDegree = data.profiles[0].individual.academic_degree;
          this.currentOrgPosition = data.profiles[0].individual.org_position;
          this.is_female = data.profiles[0].individual.is_female;
          this.currentOrganization = data.profiles[0].individual.organization;
          const currentDate = data.profiles[0].individual.birth_date
            && parserString(data.profiles[0].individual.birth_date);
          this.date = currentDate || '';
          this.avatar_img = data.profiles[0].individual.photo
            ? data.profiles[0].individual.photo : this.avatar_img;
        }
        this.loading = false;
      } catch (ex) {
        this.loginChecked = false;
        console.log('ex ---> ', ex);
      }
    },

    async onUploadFile(e) {
      const file = e.target.files || e.dataTransfer.files;
      const blob = new Blob([file[0]], { type: ['image/jpg', 'image/jpeg', 'image/png'] });
      const files = new FormData();
      files.append('img', blob);
      files.append('id', this.GETTERS_LOGIN);
      files.append('name', file[0].name);

      await this.LOAD_PHOTO(files)
        .then((res) => {
          this.$messageHelper('Фото загружено', 'success', 3000);
        });
    },

    get_params() {
      return {
        id: this.GETTERS_LOGIN,
        first_name: this.name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        birth_date: parserDate(this.date),
        phone_number: this.phone,
        academic_degree: this.currentDegree,
        org_position: this.currentOrgPosition,
        organization: this.currentOrganization,
        is_female: this.is_female,
      };
    },

    async save_btn() {
      this.boilerplate = true;
      this.loaded = true;

      await this.UPDATE_INDIVIDUAL(this.get_params())
        .then((res) => {
          if (res.status === 200) this.$messageHelper('Данные сохранены', 'success', 3000);
          this.loaded = false;
        })
        .catch((e) => {
          this.dialog = true;
          this.loaded = false;
          this.head_info = 'ошибка';
          this.info = `${e}`;
          this.$messageHelper(`${e}`, 'error', 3000);
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  }
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
